import http from '../utils/http';
import _get from 'lodash/get';

const rootUrl = '/api';
const dentalxBaseUrl = '/dentalx/api';

const goods = {
	/**
	 * 获取产品类别列表
	 * @returns
	 */
	fetchCategoryList( params ) {
		return http.get( `${dentalxBaseUrl}/dentalxListProductParam`, params, { errCode: 'system' });
	},
	/**
	 * 获取商品列表信息
	 */
	fetchProduct( params ) {
		return http.get( `${dentalxBaseUrl}/dentalxFetchProduct`, params, { errCode: 'fetchProduct' });
	},
	/**
	 * 创建需求
	 */
	saveDesignOrder( data ) {
		return http.post( `${dentalxBaseUrl}/dentalxSaveDesignOrder`, data, { errCode: 'saveDesignOrder' });
	},
	/**
	 * 导入患者订单
	 */
	getDentalList( params ) {
		return http.get( `${rootUrl}/dentalOrderListV2`, params, { errCode: 'getDentalList' });
	},
	/**
	 * 导入订单文件
	 */
	loadDesignOrderFiles( data ) {
		return http.post( `${dentalxBaseUrl}/dentalxLoadDesignOrderFiles`, data, { errCode: 'loadDesignOrderFiles' });
	},
	/**
	 * 获取影像集配置
	 */
	fetchImageSetting( params ) {
		return http.get( `${dentalxBaseUrl}/dentalxFetchImageSetting`, params, { errCode: 'fetchImageSetting' });
	},
	/**
	 * 获取
	 */
	getPreference( params ) {
		return http.get( `${dentalxBaseUrl}/dentalxGetPreference`, params, { errCode: 'getPreference' });
	},
};
export default goods;
